// Vendor libs
import React, { useEffect, useState } from "react";

// Components & Utils
import MealPlanApi from "../api/MealPlans";
import { getDays } from "../utils/DateHelper";
import { useGlobalValue } from "../utils/GlobalState";
import { setIsLoading, setErrors } from "../utils/Actions";
import { TEMPERATURES } from "../utils/Constants";

export default function ViewRecMealPlan(props) {
  const [{ sysCfg }, dispatch] = useGlobalValue();
  const [mealPlan, setMealPlan] = useState({});
  const [meals, setMeals] = useState([]);
  const plan_id = props.match.params.id;

  useEffect(() => {
    setIsLoading(true, dispatch);

    MealPlanApi.getRecurringMealPlan(plan_id)
      .then(recurringMealPlan => {

        let mealPlanMeals = [];
        recurringMealPlan.meals.map(meal => {
          if (!meal.qty) {
            return meal;
          }

          meal.temperature = (meal.temperature_id) ? TEMPERATURES[meal.temperature_id] : "";

          // Meal Property
          meal.property = "";
          if (meal.property_id > 0 && meal.properties.length > 0) {
            let properties = {};
            meal.properties.map(property => {
              properties[property.property_id] = property.name;
              return property;
            })
            meal.property = properties[meal.property_id];
          }

          mealPlanMeals.push(meal);

          return meal;
        });

        setMealPlan(recurringMealPlan);
        setMeals(mealPlanMeals);
        setIsLoading(false, dispatch);
      })
      .catch(apiErrors => {
        setErrors(apiErrors, dispatch);
        setIsLoading(false, dispatch);
      });
  }, [dispatch, plan_id]);

  if (!mealPlan.id) {
    return <></>;
  }

  return (
    <div>
      <h2>View Recurring Meal Plan</h2>
      <br />
      <div className="row"></div>

      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Meal</th>
            {sysCfg.mealordering_properties && +sysCfg.mealordering_properties === 1 ? (
              <th>Type</th>
            ) : (
              <></>
            )}
            {sysCfg.mealordering_add_meal_show_temperature && +sysCfg.mealordering_add_meal_show_temperature === 1 ? (
              <th>Temperature</th>
            ) : (
              <></>
            )}
            <th>Week</th>
            <th>Day</th>
          </tr>
        </thead>
        <tbody>
          {meals.map(meal => {
            if (meal.qty) {
              return (
                <tr key={meal.id}>
                  <td>{meal.meal_name}</td>
                  {sysCfg.mealordering_properties && +sysCfg.mealordering_properties === 1 ? (
                    <td>{meal.property}</td>
                  ) : (
                    <></>
                  )}
                  {sysCfg.mealordering_add_meal_show_temperature && +sysCfg.mealordering_add_meal_show_temperature === 1 ? (
                    <td>{meal.temperature}</td>
                  ) : (
                    <></>
                  )}
                  <td>{meal.menu_week}</td>
                  <td>{getDays()[meal.menu_day]}</td>
                </tr>
              );
            } else {
              return null;
            }
          })}
        </tbody>
      </table>
    </div>
  );
}
